import React from 'react';
import { Buttons, Dialog, DialogState, EmptyState, LoadingIndicator, useCopyText } from '../../toolympus/components/primitives';
import { useProjectTasks } from '../Tasks/useProjectTasks';
import { useProjectResolvedTasks } from '../Tasks/useProjectResolvedTasks';
import { Task } from '../Tasks/typings';
import { useFormats } from '../../toolympus/components/schemed';
import { MomentInput } from 'moment';

interface Props extends Pick<DialogState, "isOpen" | "close"> {
  projectId: string;
}

const taskToTsv = (t: Task, status: string, formatDate: (v: MomentInput) => string) => {
  return [
    t.title,
    status,
    t.due_date ? formatDate(t.due_date) : "",
    t.resolved_at ? formatDate(t.resolved_at) : "",
    t.created_at ? formatDate(t.created_at) : "",
  ].join("\t");
}

export const ProjectTasksExportDialog = (props: Props) => {
  const unresolvedTasks = useProjectTasks(props.projectId);
  const resolvedTasks = useProjectResolvedTasks(props.projectId);

  const isLoading = unresolvedTasks.isLoading || resolvedTasks.isLoading;

  const copyText = useCopyText();
  const formats = useFormats();

  const copyTasksTsv = () => {
    const result = [
      ["Задача", "Статус", "Срок", "Закрыта", "Создана"].join("\t"),
      ...unresolvedTasks.currentTasks.map(t => taskToTsv(t, "текущая", formats.formatDate)),
      ...unresolvedTasks.data.map(t => taskToTsv(t, "открытая", formats.formatDate)),
      ...resolvedTasks.data.map(t => taskToTsv(t, "закрытая", formats.formatDate)),
    ];

    copyText(result.join("\n"));
  }

  return (
    <Dialog
      dialogTitle="Экспорт задач"
      noFullscreen
      {...props}
      >
        {isLoading && 
          <Buttons style={{ justifyContent: "center", alignItems: "center" }}>
            <LoadingIndicator />
          </Buttons>}

        {!isLoading && (!unresolvedTasks.data.length && !resolvedTasks.data.length) &&
          <EmptyState text="в проекте нет задач" />}

        {!isLoading && (!!unresolvedTasks.data.length || !!resolvedTasks.data.length) &&
          <EmptyState
            text={`скопировать ${unresolvedTasks.data.length + resolvedTasks.data.length} задач в tsv`}
            onClick={copyTasksTsv}
            />}
    </Dialog>
  );
}
